import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const AuthPage = ({ mode = 'sign-in' }) => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirect') || '/';

  // eslint-disable-next-line no-unused-vars
  const isSignIn = mode === 'sign-in';

  // Redirect to new auth system
  useEffect(() => {
    const authBaseUrl = process.env.REACT_APP_AUTH_BASE_URL;
    const authNextUrl = process.env.REACT_APP_SELF_URL;
    
    if (authBaseUrl && authNextUrl) {
      // Build the full redirect URL with the path from redirectUrl parameter
      const fullRedirectUrl = `${authNextUrl}${redirectUrl}`;
      
      let redirectToAuth = `${authBaseUrl}/login/?next=${encodeURIComponent(fullRedirectUrl)}`;
      if(mode === 'sign-up')
      {
        redirectToAuth = `${authBaseUrl}/register/?next=${encodeURIComponent(fullRedirectUrl)}`;
      }
      window.location.href = redirectToAuth;
    } else {
      console.error('Auth URLs not configured in environment variables');
    }
  }, [mode, redirectUrl]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        py: 4,
      }}
    >
      <CircularProgress size={60} sx={{ color: 'primary.main', mb: 3 }} />
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: '#0f172a',
          mb: 4,
          textAlign: 'center',
        }}
      >
        Redirecting to authentication...
      </Typography>

      {/* {isSignIn ? (
        <SignIn
          routing="path"
          path="/auth/sign-in"
          signUpUrl="/auth/sign-up"
          afterSignInUrl={redirectUrl}
        />
      ) : (
        <SignUp
          routing="path"
          path="/auth/sign-up"
          signInUrl="/auth/sign-in"
          // afterSignUpUrl={process.env.REACT_APP_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL || '/manage-self'}
          afterSignUpUrl={process.env.REACT_APP_CLERK_SIGN_UP_FALLBACK_REDIRECT_URL || '/profile'}
        />
      )} */}
    </Box>
  );
};

export default AuthPage;
